import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSelector.css';

export default function LanguageSelector() {
  const { t, i18n } = useTranslation();
  const [syncError, setSyncError] = useState(false);
  useEffect(() => {
    const changed = (event) => setSyncError(event.detail === 'error');
    window.addEventListener('mz-language-sync', changed);
    return () => window.removeEventListener('mz-language-sync', changed);
  }, []);
  const language = i18n.resolvedLanguage || 'de';
  return (
    <>
    <div className="mz-language">
      <span className="mz-language-label">{t('language')}</span>
      <div className="mz-language-options" role="group" aria-label={t('language')}>
        {[['de', 'Deutsch'], ['en', 'English']].map(([code, label]) => (
          <button key={code} type="button" lang={code}
            className="mz-language-option" aria-pressed={language === code}
            onClick={() => i18n.changeLanguage(code)}>
            {label}
          </button>
        ))}
      </div>
    </div>
    {syncError && <p className="mz-language-sync-error" role="status">{t("Language saved on this device only. Account sync failed.")}</p>}
    </>
  );
}
